import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { gameUiTexts } from 'data/ui-texts';
import Button from '../button/button';
import Image from '../image/image';
import YouTube from 'react-youtube';
import Audio from '../audio/audio';
import DialogueExamples from '../dialogue-examples/dialogue-examples';
import './popup-slide.scss';

const PopupSlide = ({initialSlideIndex, pageData, togglePopup}) => {
	const [slideIndex, setSlideIndex] = useState(initialSlideIndex);
	const [videoState, setVideoState] = useState('loading');
	const [videoRef, setVideoRef] = useState(null);
	const slideData = pageData.slides[slideIndex];
	const showPrevBtn = (slideIndex > 0 ? true : false);
	const showNextBtn = Boolean(slideIndex + 1 < pageData.slides.length);


	/**
	 * Start video
	 * @param {object} e 
	 * @returns 
	 */
	const handlePlay = (e) => {
		e.stopPropagation();
		if (videoState === 'loading') return;
		if (videoRef && videoRef.playVideo) {
			setVideoState('buffering');
			videoRef.playVideo();
		}
	};

	const videoEnded = () => {
		setVideoState('ended');
	};

	useEffect(() => {
		let interval;

		if (slideData.duration && slideData.duration > 0 && videoState === 'playing' && videoRef) {
			interval = setInterval(() => {
				const currentTime = videoRef.getCurrentTime();
				if (currentTime >= slideData.duration) {
					videoRef.stopVideo();
					videoEnded();
				}
			}, 200); // Check every 200ms for precision
		}

		return () => {return clearInterval(interval);}; // Clean up interval on pause/unmount
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [videoState, videoRef]);

	return (
		<div className="PopupSlide">
			<div className="PopupSlide-content">
				{/* Image */}
				{slideData.type === 'image' && <Image type="slide" imageId={slideData.id} />}

				{/* Video (youtube) */}
				{(slideData.type === 'video' && slideData.videoType === 'youtube') &&
					<div className="PopupSlide-videoWrap">
						<YouTube 
							className={'PopupSlide-video ' + videoState} 
							videoId={slideData.videoId} 
							onReady={(e) => {setVideoRef(e.target); setVideoState('ready');}}
							onPlay={() => {setVideoState('playing');}}
							onPause={() => {setVideoState('paused');}}
							onEnd={() => {videoEnded();}}
							opts={{
								height: '100%', 
								width: '100%', 
								playerVars: {
									controls: 1
								}
							}}
						/>
						<div 
							className={'PopupSlide-videoPlayBtn ' + videoState} 
							onClick={(e) => {handlePlay(e);}} 
						/>
					</div>
				}

				{slideData.type === 'video' && slideData.videoType === 'ignite' && 
					<div className="PopupSlide-videoWrap">
						<iframe 
							title="video"
							id="ignite-video-player" 
							src={slideData.videoLink} 
							width="640" 
							height="360" 
							frameBorder="0"  
						></iframe>
					</div>
				}

				{slideData.type === 'iframe' && 
				<div className="PopupSlide-videoWrap">
					<iframe 
						title={slideData.title}
						id="ignite-video-player" 
						src={slideData.link} 
						width="640" 
						height="360" 
						frameBorder="0"  
					></iframe>
				</div>}

				{/* Audio */}
				{slideData.type === 'audio' && 
					<div className="PopupSlide-audio">
						{(slideData.image) && <Image type="slide audio" imageId={slideData.image} />}
						<Audio audioFile={slideData.audioFile} image={slideData.image ? slideData.image : null} />
					</div>
				}

				{/* text */}
				{slideData.type === 'text' && 
					<div className={'PopupSlide-text ' + slideData.id}>
						<span>{slideData.subtext}</span>
					</div>
				}


				{/* Dialogue examples */}
				{slideData.type === 'dialogue-examples' &&
					<DialogueExamples slideData={slideData} />
				} 

				{/* Prev / next buttons */}
				<div className="PopupSlide-buttons">
					{showPrevBtn && <div className="PopupSlide-prevBtn"><Button 
						classes={['red']}
						text={gameUiTexts.prevSlideBtn} 
						onClick={() => {setSlideIndex((slideIndex - 1));}} 
					/></div>} 
					{showNextBtn && <div className="PopupSlide-nextBtn"><Button 
						classes={['red']}
						text={gameUiTexts.nextSlideBtn} 
						onClick={() => {setSlideIndex((slideIndex + 1));}} 
					/></div>} 
				</div>

				{/* Close btn */}
				<div className="PopupSlide-closeBtn">
					<Button classes={['popup-close']} onClick={togglePopup} />
				</div>
			</div>

			{/* Title */}
			<div className="PopupSlide-title">
				<span>{slideData.text}</span>
			</div>
		</div>
	);
};

PopupSlide.propTypes = {
	initialSlideIndex: PropTypes.number.isRequired,
	pageData: PropTypes.object.isRequired,
	togglePopup: PropTypes.func.isRequired
};

export default PopupSlide;
